export const messages = {
  ONLY_EXCEL_FILE: "Only Excel files (.xls, .xlsx) are allowed.",
  FILE_UPLOAD_FAIL: "File upload failed!",
  INVALID_LOGIN_CREDENTIALS: "Invalid login credentials",
  COMPANY_ALREADY_EXISTS_REGISTRATION:
    "A company already exists with this registration number.",
  COMPANY_ALREADY_EXISTS_EMAIL: "A company already exists with this email.",
  TOAST_FAILED: "company Failed to registered",
  EMPLOYEE_UPLOADED_SUCCESSFULLY: "Employee updated successfully!",
  FAILED_TO_UPDATE_EMPLOYESS: "Failed to update employee.",
  MAXIMUM_ALLOWED_VALUE: "Maximum allowed value is ",
  SELECT_THE_OPTION: "Select the option to distribute based on.",
  FILL_ALL_FIELDS: "Please fill all the fields correctly.",
  ALOT_ALL_WITHIN_BUDGET: "Allote all and within the budget.",
  TEMPLATE_ADDED: "Template added successfully!",
  TEMPLATE_UPDATED: "Template updated successfully!",
  EMPLOYESS_UPLOADED_SUCCESSFULLY: "Employees uploaded successfully!",
  SDF_USER_SUCCESSFULLY: "SDF User ",
  SERVER_ERROR: "Internal Server Error",
  DELETED_SUCCESSFULLY: "Deleted Successfully",
  NO_DATA: "No Data Available.",
  EMPLOYEE_DELETED: "Employee deleted successfully!",
  FAILED_TO_DELETE_EMPLOYESS: "Failed to delete employee.",
  REMOVE_EXISTING_EMPLOYEE:
    "Remove existing employee to change the configuration.",
  EMPLOYEE_ADDED_SUCCESSFULLY: "Employee added successfully!",
  FAILED_TO_ADD_EMPLOYESS: "Failed to add employee.",
  USER_ALREADY_EXISTS: "This email is already exists.",
  TRAINING_FORM_SUBMITTED_SUCCESSFULLY: "Training Needs Form Submitted Successfully",
  SOMETHING_WENT_WRONG: "Something went wrong",
  // Prompt Master messages
  PROMPTS_SAVED_SUCCESSFULLY: "Prompts saved successfully!",
  FAILED_TO_SAVE_PROMPTS: "Failed to save prompts.",
  PROMPT_ACTIVATED: "Prompt activated successfully!",
  PROMPT_DEACTIVATED: "Prompt deactivated successfully!",
  FAILED_TO_UPDATE_PROMPT_STATUS: "Failed to update prompt status.",
  PROMPT_DELETED: "Prompt deleted successfully!",
  FAILED_TO_DELETE_PROMPT: "Failed to delete prompt.",
  PROMPTS_LOADED_SUCCESSFULLY: "Prompts loaded successfully!",
  // Cost per learner validation message (limit = COST_PER_LEARNER_LIMIT from constants)
  COST_PER_LEARNER_LIMIT_MESSAGE: (limit) =>
    `Cost per learner cannot exceed R${Number(limit).toLocaleString("en-ZA", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`,
  FAILED_TO_LOAD_PROMPTS: "Failed to load prompts.",
  SELECT_TRAINING_CATEGORY:"Please select a training category first",
  GOAL_DELETED_SUCCESSFULLY: "Goals deleted successfully!",
  SELECT_TRAINING_NAME:"Please select a Training first",
  DRAFT_SAVED_SUCCESSFULLY:"Draft saved successfully!",
  INVITE_SENT_SUCCESSFULLY:"Invite sent successfully!",
  INVITE_SENT_FAILED:"Invite sent failed!",
  MISMATCH_BUDGET: (totalBudgetValue, totalRandValue) =>  `
  Budget mismatch:
  Total Department Budget is ${totalRandValue.toFixed(2)},
  but Total Budget is ${totalBudgetValue.toFixed(2)}.
  Please adjust the department budgets so they match.
`,

  SKILLS_PLAN_MISSING_FUNCTION_BODY:
    "Generate Plan: the AI did not return usable mapping code (functionBody). Try again. If it keeps happening, check the /helper response or SETA template.",
  SKILLS_PLAN_PARSER_FAILED: (chunkLabel, technicalMessage) =>
    `Generate Plan: the AI mapping code failed ${chunkLabel}. ${technicalMessage} The job was marked as failed — try again or contact support if this continues.`,
  SKILLS_PLAN_ROW_COUNT_MISMATCH: (actual, expected) =>
    `Generate Plan: mapping produced ${actual} rows but ${expected} were expected (one per allocated training). Try again; if it repeats, the AI mapping may not match your data shape.`,
};
